export default __webpack_public_path__ + "static/media/Primia.b3f2a1a0.png";